export const PATH_KEY = 'originalPath';
export const SEARCH_KEY = 'urlSearch';
export const LOCALE_KEY = 'langLocale';
export const LOGOUT_KEY = 'logoutFromClassroom';
